import React, { useState, createContext, useContext } from "react";
import { ProSidebarProvider } from "react-pro-sidebar";
import HTMLCourseNav from "./HTMLCourseNav";
import CSSCourseNav from "./CSSCourseNav";
import JavaScriptCourseNav from "./JavaScriptCourseNav";
import ReactCourseNav from "./ReactCourseNav";
import JavaScriptCyberCourseNav from "./JavaScriptCyberCourseNav";
import PHPCourseNav from "./PHPCourseNav";
import ColorCourseNav from "./ColorCourseNav";
import { motion, useScroll, useSpring  } from "framer-motion"

const SidebarCourseContext = createContext({});

export const HTMLCourseNavProvider = ({ children }) => {
  const [sidebarRTL, setSidebarRTL] = useState(false);
  const [sidebarBackgroundColor, setSidebarBackgroundColor] =
    useState(undefined);
  const [sidebarImage, setSidebarImage] = useState(undefined);
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return (
    <ProSidebarProvider>
      <motion.div className="progress-bar" style={{ scaleX }} />
      <SidebarCourseContext.Provider
        value={{
          sidebarBackgroundColor,
          setSidebarBackgroundColor,

          sidebarImage,
          setSidebarImage,

          sidebarRTL,
          setSidebarRTL,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: sidebarRTL ? "row-reverse" : "row",
          }}
        >
          {window.location.href.toString().includes("html") ? <HTMLCourseNav /> : window.location.href.toString().includes("css") ? <CSSCourseNav /> : window.location.href.toString().includes("javascript") ? <JavaScriptCourseNav /> : window.location.href.toString().includes("php") ? <PHPCourseNav /> : window.location.href.toString().includes("react") ? <ReactCourseNav />: window.location.href.toString().includes("color-psychology") ? <ColorCourseNav /> :  window.location.href.toString().includes("cyber-script") ? <JavaScriptCyberCourseNav/> : null}
          {children}
        </div>
      </SidebarCourseContext.Provider>
    </ProSidebarProvider>
  );
};

export const useSidebarContext = () => useContext(SidebarCourseContext);
